import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Separator from '~/components/Separator';
import ToggleDefault from '~/components/ToggleDefault';
import api from '~/services/api';
import {
  tipoDivisorPreco,
  tipoNaoIncidente,
  tipoPisCofinsEntrada,
  tipoPisCofinsSaida,
} from '~/pages/Produto/constants';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import ModalTransferir from './Gtin/ModalTransferir';
import { Gtin } from './Gtin';
import { Plu } from './Plu';
import { Tab, Tabs } from 'react-bootstrap';
import { BuscaNcm } from '~/components/BuscaNcm';
import {
  InputNumber2,
  InputPeso,
  InputSelect,
  InputText,
} from '~/components/NovosInputs';
import { moedaFormatada } from '~/components/NovosInputs/InputMoney/formatMask';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import { LojaContext } from '~/context/loja';
import { moneyFormat } from '~/utils/functions';
import { AbaIbsCbs } from './Abas/AbaIbsCbs';
import { AbaIcms } from './Abas/AbaIcms';
import { AbaIpi } from './Abas/AbaIpi';
import { AbaPisCofins } from './Abas/AbaPisCofins';
import { FlagsState, MapeamentoValores, Select } from '../../types';
import { useProdutoQueries } from '../../hooks/useQueriesProduto';

const AbaGeral: React.FC = () => {
  const {
    mainLoja,
    tipoGtin,
    setTipoGtin,
    register,
    control,
    setValue,
    getValues,
    clearErrors,
    watch,
    formState: { errors },
    ncmIsFromTheProduct,
    setNcmIsFromTheProduct,
    setIpiHabilitar,
    isUpdate,
    tabGeral,
    setTabGeral,
    handleTipoItemAndIdCtb,
    flags,
    ChangeFlags,
  } = useProduto();
  const {
    tribEntrada,
    tribSaida,
    pisCofins,
    departamentos,
    unidades,
    idContabeis,
    tipoItem,
  } = useProdutoQueries();
  const unCompras = unidades.data?.unCompras ?? [];
  const unVendas = unidades.data?.unVendas ?? [];

  const { loja } = useContext(LojaContext);
  const [showModalTransferir, setShowModalTransferir] = useState(false);
  const [gtinModalTransferir, setGtinModalTransferir] = useState('');
  const [infoProduto, setInfoProduto] = useState<any>({});
  const { cod_ncm, cod_tipo_item } = watch();

  useEffect(() => {
    if (watch('ipi_tipo')?.value !== -1 && watch('ipi_tipo')?.value !== '') {
      setIpiHabilitar(false);
    }
  }, []);

  useEffect(() => {
    if (!flags?.flg_nao_pis_cofins) {
      handleChangeValoresCst('-1' as keyof MapeamentoValores);
    }
  }, [flags?.flg_nao_pis_cofins]);

  const handleChangeInput = (valores: { entrada: string; saida: string }) => {
    const entradaFiltrada = tipoPisCofinsEntrada.find((item: Select) => {
      return Number(item.value) === Number(valores.entrada);
    });
    const saidaFiltrada = tipoPisCofinsSaida.find((item: Select) => {
      return Number(item.value) === Number(valores.saida);
    });
    setValue('cst_entrada', entradaFiltrada);
    setValue('cst_saida', saidaFiltrada);
  };

  const mapeamentoValoresCst: MapeamentoValores = {
    '-1': {
      entrada: loja.cst_pis_cof_entrada,
      saida: loja.cst_pis_cof_saida,
    },
    '0': {
      entrada: loja.cst_pis_cof_ent_aliq_zero,
      saida: loja.cst_pis_cof_saida_aliq_zero,
    },
    '1': {
      entrada: loja.cst_pis_cof_ent_monof,
      saida: loja.cst_pis_cof_saida_monof,
    },
    '2': {
      entrada: loja.cst_pis_cof_ent_subst,
      saida: loja.cst_pis_cof_saida_subst,
    },
    '3': {
      entrada: loja.cst_pis_cof_ent_imune,
      saida: loja.cst_pis_cof_saida_imune,
    },
    '4': {
      entrada: loja.cst_pis_cof_ent_susp,
      saida: loja.cst_pis_cof_saida_susp,
    },
    '5': {
      entrada: loja.cst_pis_cof_ent_monof,
      saida: loja.cst_pis_cof_saida,
    },
  };

  const handleChangeValoresCst = (
    tipo: keyof MapeamentoValores,
  ): { entrada: string; saida: string } | null => {
    if (tipo in mapeamentoValoresCst) {
      const valores = mapeamentoValoresCst[tipo];
      handleChangeInput(valores);
    }
    return null;
  };

  const getProdutoNCMTipoItem = () => {
    setInfoProduto({});
    const codNcmValue = typeof cod_ncm === 'number' ? cod_ncm : cod_ncm?.value;
    if (!codNcmValue) return;
    try {
      if (isUpdate && ncmIsFromTheProduct) {
        api
          .get(`/produto/${watch('cod_produto')}/${mainLoja.cod_loja}`)
          .then((res) => {
            const { data, success } = res.data;
            if (!success) {
              setInfoProduto({});
            }

            setInfoProduto(data);
          });
      }
      if (cod_tipo_item?.value !== null && cod_tipo_item?.value !== undefined) {
        api
          .get(
            `/produto/ncm/${codNcmValue}/${cod_tipo_item.value}/${mainLoja.des_uf}`,
          )
          .then((res) => {
            const { data, success, message } = res.data;
            if (!success) {
              throw new Error(message);
            }

            setValue(
              'cod_trib_entrada',
              tribEntrada.data.find(
                (item: any) => item.value === data?.cod_trib_entrada,
              ),
            );
            setValue(
              'cod_tributacao',
              tribSaida.data.find(
                (item: any) => item.value === data?.cod_tributacao,
              ),
            );

            if (!ncmIsFromTheProduct) {
              setValue('flg_nao_pis_cofins', data?.flg_nao_pis_cofins);
              const aliqDiferenciada = data?.cod_cred_pres
                ? pisCofins.data
                  ? pisCofins.data.find(
                      (option: any) => option.value === data?.cod_cred_pres,
                    )
                  : {
                      value: null,
                      label: '=Saída',
                    }
                : {
                    value: null,
                    label: '=Saída',
                  };
              setTimeout(() => {
                setValue(
                  'tipo_nao_pis_cofins',
                  data?.flg_nao_pis_cofins
                    ? tipoNaoIncidente.find(
                        (tipo) => tipo.value === data?.tipo_nao_pis_cofins,
                      )
                    : null,
                );
                setValue('entrada_pis_cofins', aliqDiferenciada);
              }, 10);
              setValue(
                'des_sped',
                data?.des_tab_sped ? data?.des_tab_sped : null,
              );
              setValue(
                'cod_sped',
                data?.cod_tab_sped
                  ? data.cod_tab_sped.toString().padStart(3, '0')
                  : null,
              );

              setValue(
                'flg_veda_cred',
                infoProduto.produtoLoja && isUpdate
                  ? infoProduto?.produtoLoja?.flg_veda_cred
                  : data?.flg_veda_cred,
              );
              setValue(
                'flg_veda_cred_lim',
                infoProduto.produtoLoja && isUpdate
                  ? infoProduto?.produtoLoja?.flg_veda_cred_lim
                  : data?.flg_veda_cred_lim,
              );
              setValue(
                'per_veda_cred_lim',
                infoProduto.produtoLoja && isUpdate
                  ? infoProduto?.produtoLoja?.per_veda_cred_lim
                    ? moneyFormat(infoProduto?.produtoLoja?.per_veda_cred_lim)
                    : ''
                  : data?.per_veda_cred_lim
                  ? moneyFormat(data?.per_veda_cred_lim)
                  : '',
              );
            }
          });
      }
    } catch (e: any) {
      toast.error(e.message);
    }
  };

  useEffect(() => {
    getProdutoNCMTipoItem();
  }, [cod_ncm, cod_tipo_item]);

  useEffect(() => {
    const { tipo_nao_pis_cofins } = getValues();
    if (tipo_nao_pis_cofins) {
      handleChangeValoresCst(
        tipo_nao_pis_cofins.value as keyof MapeamentoValores,
      );
    }
  }, [watch('tipo_nao_pis_cofins')]);

  return (
    <>
      <ModalTransferir
        show={showModalTransferir}
        gtin={gtinModalTransferir}
        handleModal={setShowModalTransferir}
      />

      <div className="row">
        {/* Form antes codigo de barras */}
        <Col sm={12} md={12} lg={9} xl={9}>
          <Row>
            <Col
              sm={12}
              md={6}
              lg={5}
              xl={4}
              className="d-flex align-items-center justify-content-space-between"
            >
              <Plu />
            </Col>

            <Col sm={12} md={3} lg={2} xl={2}>
              <ToggleDefault
                labelText="Fora de Linha?"
                setChecked={flags.flg_fora_linha}
                onSwitch={() => {
                  ChangeFlags((prev: FlagsState) => ({
                    flg_fora_linha: !prev.flg_fora_linha,
                  }));
                }}
              />
            </Col>

            <Col sm={12} md={3} lg={2} xl={2}>
              <ToggleDefault
                labelText="Bebida Alcoólica?"
                setChecked={flags.flg_alcoolico}
                onSwitch={() => {
                  ChangeFlags((prev: FlagsState) => ({
                    flg_alcoolico: !prev.flg_alcoolico,
                  }));
                }}
              />
            </Col>

            {/* CÓDIGO ABAIXO COMENTADO PROVISORIAMENTE - FAVOR NÃO APAGAR */}
            {/* <Col sm={12} md={3} lg={3} xl={3}>
              <InputSelect
                label="Tipo de Variação/Grade"
                placeholder="Selecione"
                name="tipo_variacao"
                register={register}
                isError={false}
                control={control}
                options={[
                  { value: 0, label: 'Não possui' },
                  { value: 1, label: 'Possui grade' },
                ]}
                changeSelected={async (selected) => {
                  if (itemsAbaGrade.length > 0 && isUpdate) {
                    setValue('tipo_variacao', {
                      value: 1,
                      label: 'Possui grade',
                    });

                    if (selected.value === 0) {
                      toast.warning(
                        'Produto com variação/grade, não permitido alterar seu tipo.',
                      );

                      setTimeout(() => {
                        setValue('tipo_variacao', {
                          value: 1,
                          label: 'Possui grade',
                        });
                        const input: HTMLInputElement | null =
                          document.querySelector('input[name="tipo_variacao"]');

                        if (input) input.value = 'Possui grade';
                      }, 50);

                      return;
                    }
                  }

                  handleHasVariacaoGrade(selected.value !== 0);
                  setValue('tipo_variacao', {
                    value: selected.value,
                    label: selected.label,
                  });

                  if (selected.value === 1) {
                    setTimeout(() => {
                      setValue('cod_similar', {
                        label: 'Nenhum Similar Selecionado',
                        value: undefined,
                      });

                      changeFormAssociado(formAssociadoBlank);
                      changeFormAssociado({
                        ...formAssociado,
                        flg_atual_vda_assoc: {
                          ...formAssociado.flg_atual_vda_assoc,
                          value: false,
                        },
                      });

                      setAssociadosPai([]);
                      setAssociadosFilho([]);
                    }, 50);
                  }
                }}
              />
            </Col> */}
          </Row>

          <div className="col-sm-12 col-md-12 ">
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <InputText
                  maxLength={100}
                  name="des_produto"
                  label="Descrição *"
                  autoComplete="off"
                  placeholder="Informe a Descrição"
                  caseInput="upper"
                  toLowerCase={false}
                  register={register}
                  control={control}
                  isError={!!errors.des_produto}
                />
              </div>

              <div className="col-sm-12 col-md-5">
                <InputText
                  maxLength={50}
                  label="Reduzida"
                  name="des_reduzida"
                  autoComplete="off"
                  placeholder="Informe a Descrição Reduzida"
                  caseInput="upper"
                  toLowerCase={false}
                  control={control}
                  register={register}
                  isError={!!errors.des_reduzida}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 col-md-12">
                <InputSelect
                  label="Departamento *"
                  placeholder="Selecione o Departamento"
                  name="cod_departamento"
                  register={register}
                  isError={!!errors.cod_departamento}
                  control={control}
                  options={departamentos.data as SelectType[]}
                  changeSelected={(selected: any) => {
                    setValue('cod_departamento', selected);
                    setNcmIsFromTheProduct(false);

                    handleTipoItemAndIdCtb();
                    clearErrors('cod_departamento');
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12">
                <BuscaNcm
                  name="cod_ncm"
                  control={control}
                  isUpdate={isUpdate}
                  init={!!errors.cod_ncm}
                  invalid={!!errors.cod_ncm}
                  isDisabled={!watch('cod_departamento')?.value}
                  placeholder={
                    !watch('cod_departamento')?.value
                      ? 'Selecione o Departamento'
                      : 'Informe pelo menos 3 caracteres do Número, Descrição ou CEST'
                  }
                />
              </div>
            </div>

            <Row>
              <Col sm={12} md={6}>
                <InputSelect
                  label="Tipo do Item *"
                  name="cod_tipo_item"
                  placeholder="- Selecione a Categoria -"
                  register={register}
                  isError={!!errors.cod_tipo_item}
                  control={control}
                  options={tipoItem.data as SelectType[]}
                  changeSelected={(selected) => {
                    clearErrors('cod_tipo_item');
                    setValue('cod_tipo_item', selected);
                    getProdutoNCMTipoItem();
                  }}
                />
              </Col>

              <Col sm={12} md={6}>
                <InputSelect
                  label="Indentificação Contábil *"
                  name="cod_id_ctb"
                  placeholder="- Selecione um ID Contábil -"
                  register={register}
                  isError={!!errors.cod_id_ctb}
                  control={control}
                  options={idContabeis.data as SelectType[]}
                  changeSelected={(selected) => {
                    clearErrors('cod_id_ctb');
                    setValue('cod_id_ctb', selected);
                  }}
                />
              </Col>
            </Row>
          </div>
        </Col>

        {/* Codigo De barras */}
        <Col sm={12} md={12} lg={3} xl={3}>
          <Gtin
            onShowModalChanged={setShowModalTransferir}
            onGtinModalChanged={setGtinModalTransferir}
            tipoGtin={tipoGtin}
            setTipoGtin={setTipoGtin}
          />
        </Col>
      </div>

      {/* Fiscal */}
      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          <Separator labelText="Fiscal" />
        </Col>

        <Col
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{
            minHeight: `${
              tabGeral === 'pisCofins' || tabGeral === 'ipi' ? '200px' : '250px'
            } `,
          }}
        >
          <Tabs
            id="controlled-produto"
            activeKey={tabGeral}
            onSelect={(k) => setTabGeral(k)}
          >
            <Tab eventKey="icms" title="ICMS">
              <AbaIcms />
            </Tab>

            <Tab eventKey="pisCofins" title="PIS/COFINS">
              <AbaPisCofins />
            </Tab>

            <Tab eventKey="ipi" title="IPI">
              <AbaIpi />
            </Tab>

            <Tab eventKey="ibsCbs" title="IBS/CBS">
              <AbaIbsCbs />
            </Tab>
          </Tabs>
        </Col>
      </Row>
      {/* UNIDADE / EMBALAGEM */}

      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          <Separator labelText="Unidade / Embalagem - Compra" />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputSelect
            id="uniCompra"
            label="Unidade"
            name="des_unidade_compra"
            register={register}
            isError={!!errors.des_unidade_compra}
            control={control}
            options={unCompras as SelectType[]}
            changeSelected={(selected) => {
              setValue('des_unidade_compra', selected);
            }}
          />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputNumber2
            label="C/"
            min={1}
            max={99999}
            maxLength={5}
            placeholder=""
            name="qtd_embalagem_compra"
            register={register}
            control={control}
            isError={!!errors.qtd_embalagem_compra}
            onBlur={(event: ChangeEvent<HTMLInputElement>) => {
              if (Number(event.target.value) <= 0)
                setValue('qtd_embalagem_compra', 1);
            }}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              if (Number(event.target.value) <= 99999) {
                setValue('qtd_embalagem_compra', event.target.value);
              }
            }}
          />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputPeso
            label="Peso"
            min={0.001}
            placeholder=""
            decimals={3}
            name="val_peso"
            register={register}
            control={control}
            isError={!!errors.val_peso}
            onChange={(ev: any) => {
              const { value } = ev.target;

              const serializedValue = moedaFormatada(value, 3);
              setValue('val_peso', serializedValue);
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          <Separator labelText="Unidade / Embalagem - Venda" />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputSelect
            id="uniVenda"
            label="Unidade"
            name="des_unidade_venda"
            register={register}
            isError={!!errors.des_unidade_venda}
            control={control}
            options={unVendas as SelectType[]}
            changeSelected={(selected) => {
              setValue('des_unidade_venda', selected);
            }}
          />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputNumber2
            label="C/"
            min={0}
            max={99999}
            maxLength={5}
            placeholder=""
            name="qtd_embalagem_venda"
            register={register}
            control={control}
            isError={!!errors.qtd_embalagem_venda}
            onBlur={(event: ChangeEvent<HTMLInputElement>) => {
              if (Number(event.target.value) <= 0)
                setValue('qtd_embalagem_venda', 1);
            }}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              if (Number(event.target.value) <= 99999) {
                setValue('qtd_embalagem_venda', event.target.value);
              }
            }}
          />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputPeso
            label="Peso Líquido"
            min={0.01}
            placeholder=""
            decimals={3}
            name="val_peso_emb"
            register={register}
            control={control}
            isError={!!errors.val_peso_emb}
            onBlur={(ev: any) => {
              if (ev.target.value === '' || ev.target.value === '0,000') {
                setValue('val_peso_emb', '1,000');
              }
            }}
            onInput={(ev: any) => {
              const { value } = ev.target;

              const serializedValue = moedaFormatada(value, 3);
              setValue('val_peso_emb', serializedValue);
            }}
          />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputPeso
            label="Peso Bruto"
            min={0.01}
            placeholder=""
            decimals={3}
            name="val_peso_bruto"
            register={register}
            control={control}
            isError={!!errors.val_peso_bruto}
            onBlur={(ev: any) => {
              if (ev.target.value === '' || ev.target.value === '0,000') {
                setValue('val_peso_bruto', '1,000');
              }
            }}
            onInput={(ev: any) => {
              const { value } = ev.target;

              const serializedValue = moedaFormatada(value, 3);
              setValue('val_peso_bruto', serializedValue);
            }}
          />
        </Col>

        <Col sm={12} md={3} lg={3} xl={2}>
          <InputPeso
            label="Divisor de Preços"
            min={0.01}
            placeholder=""
            decimals={3}
            name="qtd_divisor_preco"
            register={register}
            control={control}
            isError={!!errors.qtd_divisor_preco}
            onBlur={(ev: any) => {
              if (ev.target.value === '' || ev.target.value === '0,000') {
                setValue('qtd_divisor_preco', '1,000');
              }
            }}
            onInput={(ev: any) => {
              const { value } = ev.target;

              const serializedValue = moedaFormatada(value, 3);
              setValue('qtd_divisor_preco', serializedValue);
            }}
          />
        </Col>

        <Col sm={12} md={2} lg={2} xl={2}>
          <InputSelect
            label="Tipo"
            name="des_unidade_medida_preco"
            register={register}
            isError={!!errors.des_unidade_medida_preco}
            control={control}
            options={tipoDivisorPreco as SelectType[]}
            changeSelected={(selected) => {
              setValue('des_unidade_medida_preco', selected);
            }}
          />
        </Col>
      </Row>
    </>
  );
};
export default AbaGeral;
